import { render, staticRenderFns } from "./Szechenyi.vue?vue&type=template&id=60327f8b&scoped=true&"
import script from "./Szechenyi.vue?vue&type=script&lang=js&"
export * from "./Szechenyi.vue?vue&type=script&lang=js&"
import style0 from "./Szechenyi.vue?vue&type=style&index=0&id=60327f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60327f8b",
  null
  
)

export default component.exports